export default "__VITE_ASSET__Bd794Yiu__"